import { css } from '@linaria/core'
import { type FC, lazy, Suspense, useState } from 'react'
import { Button } from '#components/Button'
import { Checkbox } from '#components/Checkbox'
import { Spinner } from '#components/Spinner'
import { setIsEnabled } from '#store/requestObserverSlice'
import { useSharedAppDispatch, useSharedAppSelector } from '#store/sharedBaseStore'

const LazyRequestMonitorModal = lazy(async () => {
  const { RequestMonitorModal } = await import('./RequestMonitorModal.tsx')
  return { default: RequestMonitorModal }
})

const className = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  > .checkbox label {
    padding: 0;  
  }
`

export const RequestMonitorButton: FC = () => {
  const [open, setOpen] = useState(false)
  const dispatch = useSharedAppDispatch()
  const { isEnabled } = useSharedAppSelector((x) => x.requestObserver)

  return (
    <div className={className}>
      <Button
        onClick={() => {
          setOpen(!open)
        }}
        kind="primary"
        size="xs"
        className="flex"
      >
        Show Request Monitor
      </Button>

      <Checkbox
        className="checkbox"
        checked={isEnabled}
        label="Active"
        onChange={(evt) => {
          dispatch(setIsEnabled(evt.currentTarget.checked))
        }}
      />

      <Suspense fallback={<Spinner size="xxs" />}>{open && <LazyRequestMonitorModal onOpenChange={setOpen} open={open} />}</Suspense>
    </div>
  )
}
